export default {
    mobile: '375px',
    tablet: '740px',
    laptop: '1124px',
    desktop: '1380px',
};
